// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"edcc92c1","453":"ace21015","988":"ba493df4"}[chunkId] + ".chunk.js";
};